/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { isAlive } from 'mobx-state-tree';
import { Flyout, Label, Link } from '@ba/ba-ui-carbon-toolkit';

import './BadgeDecoration.scss';

@observer
class BadgeTooltip extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		this._onScrollhandler = this._onScroll.bind(this);
		window.addEventListener('scroll', this._onScrollhandler, true);
	}

	componentWillUnmount() {
		if (this._onScrollhandler) {
			window.removeEventListener('scroll', this._onScrollhandler, true);
			this._onScrollhandler = null;
		}
		this.props.model = null;
	}

	_onScroll(event) {
		if (event.target.className !=='explore__badge-decoration__menu') {
			this.resetFlyout();
		}
	}

	getBadgeFlyoutContent() {
		const badgesInfo = this.props.model.getBadgesInfo();
		const items = [];
		let name;
		for (name in badgesInfo) {
			items.push(
				<div key={items.length}>
					<Label className='explore__badge-decoration__menu__title' label={badgesInfo[name].label}/>
				</div>
			);
			badgesInfo[name].drivers.forEach((entry) => {
				items.push(
					this._getEntry(entry, items.length)
				);
			});
		}

		const badgeContent = (
			<div className='explore__badge-decoration__menu' walkme-data-id='badge-menu'>
				{items}
			</div>
		);

		return badgeContent;
	}

	_getEntry(entry, key) {
		return 	(
			<div key={key} className='explore__badge-decoration__menu__item'>
				<Link onClick={() => {
					this._onClickEntry(entry);
				}}>{entry.label}</Link>
			</div>
		);
	}

	_onClickEntry(entry) {
		this.props.layoutOwner.parentLayout.model.addCometCardForCorrelation(entry);
		this.resetFlyout();
	}

	render() {
		let content = null;
		if (this.props.model.isTooltipOpen()) {
			const position = this.props.model.getPosition();
			content = (<div className='explore__badge-decoration' style={{ top: position.top + 'px', left: position.left +'px', height: position.height +'px', width: position.width +'px' }}><Flyout
				trigger={'Click'}
				alignment={true}
				domNodeToAttachTo={document.body}
				onClose={this.resetFlyout.bind(this)}
			>
				{this.getBadgeFlyoutContent()}
			</Flyout></div>);
		}

		return content;
	}

	resetFlyout() {
		this.props.model && this._isAliveModel() && this.props.model.closeTooltip();
	}

	_isAliveModel() {
		return isAlive(this.props.model);
	}

}

BadgeTooltip.propTypes = {
	model: PropTypes.object,
	layoutOwner: PropTypes.object
};

export default BadgeTooltip;



// WEBPACK FOOTER //
// ./src/js/components/badges/BadgeTooltip.js